import React, {useContext, useEffect, useState} from 'react';
import {FormattedMessage} from "react-intl";

// Components
import PageTitle from "components/WMS/Mobile/PageTitle";
import WmsMobileLayout from "../wmsMobileLayout";

// Local Components
import ShippingMethodDrawer from "./components/ShippingMethodDrawer";
import ShippingMethodItem from "./components/ShippingMethodItem";

// Context
import {WMSContext} from "../context/WMSContext";

// Utils
import {ShipmentStatus} from "utils/ShipmentStatus";

// API
import {list} from 'api/shipment/list';

function Shipping(props) {
    const [shippingMethods, setShippingMethods] = useState([]);
    const [selectedShippingMethod, setSelectedShippingMethod] = useState(null);

    const {currentInventory} = useContext(WMSContext);

    useEffect(() => {
        if (!currentInventory) {
            return;
        }

        getShipments();
    }, [currentInventory]);

    function getShipments() {
        if (!currentInventory) {
            return;
        }

        list(`inventoryId=${currentInventory.id}&status=${ShipmentStatus.READY_TO_BE_SHIPPED}&shipmentContainerType=tipper`).then((res) => {
            let tempShipment = res["hydra:member"]

            tempShipment = tempShipment.filter(shipment => currentInventory.id !== shipment.shippingMethod.destinationInventory)

            setShippingMethods(groupByShippingMethod(tempShipment));
            setSelectedShippingMethod(null)
        })
    }

    function groupByShippingMethod(shipments) {
        const groupedShipments = {};

        shipments.forEach(shipment => {
            if (!shipment.container || !shipment.shippingMethod) {
                return;
            }

            const shippingMethod = shipment.shippingMethod;
            const shippingMethodId = shippingMethod.id;
            const containerId = shipment.container.id;

            if (!groupedShipments[shippingMethodId]) {
                groupedShipments[shippingMethodId] = {
                    'shippingMethod': shippingMethod,
                    'containers': {},
                    'shipmentCount': 0,
                };
            }

            groupedShipments[shippingMethodId]['shipmentCount'] += 1;

            if (!groupedShipments[shippingMethodId].containers[containerId]) {
                groupedShipments[shippingMethodId].containers[containerId] = {
                    'container': shipment.container,
                    'shipments': [],
                    'shipmentCount': 0,
                };
            }

            groupedShipments[shippingMethodId].containers[containerId].shipments.push(shipment);
            groupedShipments[shippingMethodId].containers[containerId].shipmentCount += 1;
        });

        // converti les containers en tableau pour chaque shipping method
        for (const entry of Object.values(groupedShipments)) {
            entry.containers = Object.values(entry.containers);
        }

        return groupedShipments;
    }

    return (
        <WmsMobileLayout className="wms-test-component">
            <WmsMobileLayout.LeftHeader>
            </WmsMobileLayout.LeftHeader>
            <WmsMobileLayout.RightHeader>
            </WmsMobileLayout.RightHeader>
            <WmsMobileLayout.Content>
                <PageTitle
                    title={<FormattedMessage id='wms.shipping.title' />}
                    subtitle={<FormattedMessage id='wms.shipping.subtitle' />}
                />
                {shippingMethods && Object.entries(shippingMethods).map(([shippingMethodId, entry], index) => (
                    <ShippingMethodItem
                        key={shippingMethodId}
                        name={entry.shippingMethod.name}
                        discr={entry.shippingMethod.discr}
                        shipmentCount={entry.shipmentCount}
                        onClick={() => setSelectedShippingMethod({...entry})}
                    />
                ))}
                <ShippingMethodDrawer
                    shippingMethod={selectedShippingMethod}
                    open={!!selectedShippingMethod}
                    handleClose={() => setSelectedShippingMethod(null)}
                    refreshShippingMethods={getShipments}
                />
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    );
}

export default Shipping;
